"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeModificationRequestItemMetadata = void 0;
const createSomeModificationRequestItemMetadata = ({ feild = 'duration', value = '00:15', } = {}) => ({
    [feild]: value,
});
exports.createSomeModificationRequestItemMetadata = createSomeModificationRequestItemMetadata;
